import { render } from "./Q3Simple.vue?vue&type=template&id=d0e56d26"
import script from "./Q3Simple.vue?vue&type=script&lang=js"
export * from "./Q3Simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__